<script lang="ts">
import { computed, provide, useTemplateRef } from 'vue';

import { PhxsgIcon } from '@sg/src/View/Components/Atoms/Icon';
import {
  ExposedPhxsgAutocompleteMethod,
  PhxsgAutocompleteProps as PhxsgCoreAutocompleteProps,
  PhxsgAutocomplete as PhxsgCoreAutocomplete,
} from '@sg-core/src/View/Components/Molecules/Autocomplete';
import '@sg-core/src/View/Components/Atoms/Button/button.css';
import '@sg/src/View/Components/Atoms/Button/button.css';

export type PhxsgAutocompleteProps = Omit<
  PhxsgCoreAutocompleteProps,
  'buttonClass' | 'formFieldClass' | 'helpClass' | 'inputClass' | 'labelClass'
>;
</script>

<script setup lang="ts">
const props = defineProps<PhxsgAutocompleteProps>();

const autocompleteRef = useTemplateRef('autocompleteRef');

provide('PhxsgIcon', PhxsgIcon);

const componentProps = computed(() => ({
  formFieldClass: ['phxsg-autocomplete-field'],
  labelClass: [
    'phxsg-autocomplete-label',
    {
      'phxsg-autocomplete-label--error': props.error,
    },
  ],
  inputClass: [
    'phxsg-autocomplete-input',
    {
      'phxsg-autocomplete-input--invalid': props.error,
    },
  ],
  helpClass: [
    'phxsg-autocomplete-helper-text',
    {
      'phxsg-autocomplete-helper-text--error': props.error,
    },
  ],
  buttonClass: ['phxsg-btn phxsg-btn--icon-only phxsg-btn--icon'],
}));

const setValue = (value: string): void => {
  autocompleteRef.value?.setValue(value);
};

defineExpose<ExposedPhxsgAutocompleteMethod>({ setValue });
</script>

<template>
  <PhxsgCoreAutocomplete ref="autocompleteRef" v-bind="{ ...props, ...componentProps }">
    <template v-for="(_, slotName) in $slots" #[slotName]="slotData">
      <slot :name="slotName" v-bind="slotData" />
    </template>
  </PhxsgCoreAutocomplete>
</template>

<style src="./autocomplete.css" />
